import Lazyload from 'lazyload';
import '../scss/videoDetail.scss';
import $ from 'jquery';
import videojs from 'video.js';
import 'video.js/dist/video-js.min.css';
import Swiper from 'swiper';
import { FreeMode } from 'swiper/modules';
import 'swiper/css';
import Player from 'video.js/dist/types/player';
import {
  fetchAddReadCountByLog,
  fetchAddSubscribe,
  fetchCommentList,
  fetchContentPropertie,
  fetchDelSubscribe,
  fetchMediaInfoV3,
  fetchRelatedContent,
  fetchSiteJson,
} from '../apis/api';
import initWxSdk from './wxSdk';
import {
  browerVersion,
  getBrowerAppId,
  getSingleValueFromInput,
  getUrlQuery,
  isHideDownloadGuide,
  uuid,
} from './utils';
import initNewsTemplate from './newsTemplate';
import { getUserInfo } from './appSdk';
import YouMeng from './YouMeng';
import NanFang from './NanFang';
import ZhongXuan from './ZhongXuan';
import trackArticleDetailPageView from './trackZhongXuan';

const commentRight = require('../assets/images/comment-right.png');
const videoPlay = require('../assets/images/video-play.png');
const commentLike = require('../assets/images/comment-like.png');

Swiper.use([FreeMode]);

let appId = uuid();
let userId = '';
const version = browerVersion();

const Component = videojs.getComponent('Component');
// 自定义播放按钮，当在APP中点击时调用APP端的视频播放
class CustomPlayButton extends Component {
  divDom: null | Element = null;

  constructor(
    player: Player,
    options: { fn?: () => any; children?: any[]; className?: string } = {},
  ) {
    super(player, options);
    (this as any).on('click', () => {
      if (options.fn) {
        options.fn();
      }
    });
  }

  createEl() {
    this.divDom = videojs.dom.createEl('div', {
      className: 'custom-play-button vjs-custom-play-button',
    });
    const imgDom = videojs.dom.createEl('img', {
      style: 'width: 14px; height: 14px;',
      src: videoPlay,
      className: 'vjs-custom-play-btn',
    });
    videojs.dom.appendContent(this.divDom, imgDom);
    return this.divDom;
  }
}
videojs.registerComponent('CustomPlayButton', CustomPlayButton);
const initVideo = () => {
  // 引入video.js
  $('.container').find('video').addClass('video-js vjs-fluid').attr({
    'webkit-playsinline': true,
    playsinline: true,
    'x5-video-player-type': 'h5',
  });
  $('video').each((index, el) => {
    const player = videojs(el, {
      fluid: true,
      controls: true, // 当在app中时不显示原生播放按钮
      playbackRates: [0.75, 1, 1.25, 1.5, 2],
      poster: el.getAttribute('poster') || '',
    });
    player.on('loadedmetadata', () => {
      const videoHeight = player.videoHeight();
      const videoWidth = player.videoWidth();
      if (videoWidth < videoHeight && !el.getAttribute('poster')) {
        player.poster(process.env.DEFAULT_IMAGE_9_16);
        el.setAttribute('poster', process.env.DEFAULT_IMAGE_9_16 as string);
      } else if (videoWidth >= videoHeight && !el.getAttribute('poster')) {
        player.poster(process.env.DEFAULT_IMAGE_16_9);
        el.setAttribute('poster', process.env.DEFAULT_IMAGE_16_9 as string);
      }
    });
    player.on('play', () => {
      player.getChild('CustomPlayButton')?.addClass('hidden-btn');
    });
    player.addChild('CustomPlayButton', {
      fn: () => {
        player.play();
      },
    });
  });
};
/**
 * 处理所有媒体号的基础信息
 */
const initAllMedia = () => {
  // 普通媒体号轮播效果
  const notLeaderMediaLinkDoms = $('.media-box-link');
  const notLeaderMediaListDom = $('#media-list');
  if (
    notLeaderMediaLinkDoms &&
    notLeaderMediaLinkDoms.length &&
    notLeaderMediaListDom &&
    notLeaderMediaListDom.length
  ) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const swiper = new Swiper('#media-list', {
      slidesPerView: 'auto',
      freeMode: true,
      centerInsufficientSlides: true,
      breakpoints: {
        320: {
          spaceBetween: 15,
        },
        650: {
          spaceBetween: 20,
        },
      },
    });
  }
  $('.media-leader-subscribe').hide();
  $('.media-leader-del-subscribe').hide();
  $('.media-leader-more').css('display', 'flex');
};

/**
 * 初始化领导媒体号的功能
 * @returns
 */
const initMediaLeader = () => {
  if (version.myApp) {
    const siteId = getSingleValueFromInput('siteId');
    const mediaLeaderLinkDoms = $('.exist-media-leader-link');
    // 获取媒体号基础信息并根据userId判断是否已经关注
    if (userId && mediaLeaderLinkDoms && mediaLeaderLinkDoms.length) {
      const mediaInfoPromises: Promise<false | Media.MediaData>[] = [];
      mediaLeaderLinkDoms.each((_, el) => {
        const { id } = el.dataset;
        if (id) {
          mediaInfoPromises.push(fetchMediaInfoV3(siteId, id, appId, userId));
        } else {
          mediaInfoPromises.push(
            new Promise((resolve) => {
              resolve(false);
            }),
          );
        }
      });
      Promise.all(mediaInfoPromises).then((reslist) => {
        reslist.forEach((item, index) => {
          if (!item) {
            return;
          }
          if (Number(item.isSubscribe)) {
            const el = mediaLeaderLinkDoms[index];
            $(el).find('.media-leader-subscribe').hide();
            $(el).find('.media-leader-del-subscribe').css('display', 'flex');
          }
        });
      });
    }
    // 关注按钮的点击事件，若未登录则调用app登录功能，若已登录则调用接口关注
    $('.media-leader-subscribe').on('click', (evt) => {
      evt.stopPropagation();
      const mediaLeaderDom = $(evt.currentTarget).parents(
        '.exist-media-leader-link',
      );
      const { id } = mediaLeaderDom[0].dataset;
      if (id && userId) {
        fetchAddSubscribe(siteId, id, appId, userId).then((res) => {
          if (Number(res.status) === 200) {
            mediaLeaderDom.find('.media-leader-subscribe').hide();
            mediaLeaderDom
              .find('.media-leader-del-subscribe')
              .css('display', 'flex');
          }
        });
      } else if (id && !userId) {
        getUserInfo((result) => {
          if (result && result.userId) {
            userId = result.userId;
          }
        });
      }
    });
    // 取消关注按钮的点击事件，若未登录则调用app登录功能（逻辑上不存在该事件），若已登录则调用接口取消关注
    $('.media-leader-del-subscribe').on('click', (evt) => {
      evt.stopPropagation();
      const mediaLeaderDom = $(evt.currentTarget).parents(
        '.exist-media-leader-link',
      );
      const { id } = mediaLeaderDom[0].dataset;
      if (id && userId) {
        fetchDelSubscribe(siteId, id, appId, userId).then((res) => {
          if (Number(res.status) === 200) {
            mediaLeaderDom
              .find('.media-leader-subscribe')
              .css('display', 'flex');
            mediaLeaderDom.find('.media-leader-del-subscribe').hide();
          }
        });
      } else if (id && !userId) {
        getUserInfo((result) => {
          if (result && result.userId) {
            userId = result.userId;
          }
        });
      }
    });
  }
};
/**
 * 生成评论html
 * @param item
 * @returns
 */
const getCommentHtml = (item: RMT.CommentList) => {
  const commentAvatarHtml = `<img class="comment-avatar lazyload" src="${process.env.DEFAULT_AVATAR}" data-src="${item.headImg}" onerror="this.src='${process.env.DEFAULT_AVATAR}'"
    alt="${item.username}">`;
  const commentReplyHtml = `<div class="comment-reply-box">
      <div class="launch-app-btn" name="launch-app-btn" data-style="comment-reply-style">
        <a name="download-link" class="download-link">
          <div class="comment-reply">回复<img style="width: 16px;height: 16px;" src="${commentRight}" alt="回复"></div>
        </a>
      </div>
    </div>`;
  const commentUsernameHtml = `<span class="comment-nickname">${item.username}</span>`;
  const commentLikeHtml = `<div class="like-unlike">
      <div class="comment-like">
        <div class="launch-app-btn" name="launch-app-btn" data-style="like-unlike-style">
          <a name="download-link" class="download-link">
            <img class="comment-like-icon" src="${commentLike}" alt="点赞">
          </a>
        </div>
      </div>
    </div>`;
  const commentHeaderHtml = `<div class="comment-header">${commentUsernameHtml}${commentLikeHtml}</div>`;
  const commentEmotion = `<img class="comment-emotion" src="${item.txt}" />`;
  const commentBodyHtml = `<div class="comment-body">${item.emotion ? commentEmotion : item.txt
    }</div>`;
  const commentDetailHtml = `<div class="comment-detail">${commentHeaderHtml}${commentBodyHtml}${commentReplyHtml}</div>`;
  return `<div class="comment-box">${commentAvatarHtml}${commentDetailHtml}</div>`;
};

/**
 * 获取稿件评论
 * @param downloadUrl
 */
const initComment = (downloadUrl: string) => {
  if (!version.myApp) {
    const newsId = getSingleValueFromInput('newsId');
    const siteId = getSingleValueFromInput('siteId');
    fetchCommentList(newsId, siteId, appId).then((res) => {
      if (Number(res.status) === 200 && res.list.length) {
        $('#article-comment').show();
        const commentHtmls = res.list.map((item) => getCommentHtml(item));
        $('#comment-list').html(commentHtmls.join(''));
        $('#article-comment')
          .find('a[name="download-link"]')
          .attr('data-href', downloadUrl);
        if (!version.mobile) {
          $('#article-comment')
            .find('a[name="download-link"]')
            .attr('href', downloadUrl);
        }
        // eslint-disable-next-line no-new
        new Lazyload($('#article-comment').find('.comment-avatar'));
        initWxSdk({
          launchAppBtn: [
            {
              attr: 'class',
              value: 'comment-like',
            },
            {
              attr: 'class',
              value: 'comment-reply-box',
            },
            {
              attr: 'id',
              value: 'more-comment-box',
            },
          ],
        });
      }
    });
  }
};
/**
 * 初始化sitejson
 */
const initSiteJson = () => {
  if (!version.myApp) {
    fetchSiteJson().then((res: Site.SiteJson) => {
      initComment(res.downloadUrl);
      if (isHideDownloadGuide()) {
        return;
      }
      const headerGuideBox = $('#header-guide-box');
      if (!headerGuideBox || !res.name) {
        return;
      }
      // 设置下载链接
      headerGuideBox
        .find('a[name="download-link"]')
        .attr('data-href', res.downloadUrl)
        .attr('alt', res.name);
      // 设置引导图片
      headerGuideBox
        .find('img[name=guide-image]')
        .attr('src', res.guidePic)
        .attr('alt', res.name);
      headerGuideBox.find('img[name=guide-image]').on('load', (evt) => {
        const { clientWidth } = document.body;
        let imageHeight = '';
        let imageWidth = '';
        const { naturalHeight, naturalWidth } =
          evt.currentTarget as HTMLImageElement;
        if (clientWidth > 650) {
          imageWidth = '650px';
          imageHeight = `${(650 / naturalWidth) * naturalHeight}px`;
        } else {
          imageWidth = `${clientWidth}px`;
          imageHeight = `${(clientWidth / naturalWidth) * naturalHeight}px`;
        }
        $(evt.currentTarget).css({
          height: imageHeight,
          width: imageWidth,
        });
        initWxSdk({
          launchAppBtn: [
            {
              attr: 'id',
              value: 'header-guide-box',
            },
          ],
        });
      });
      // 点击关闭按钮的事件
      headerGuideBox.find('img[name="close-guide"]').each((index, el) => {
        $(el).on('click', (evt) => {
          evt.preventDefault();
          evt.stopPropagation();
          headerGuideBox.hide();
        });
      });
    });
  }
};

/**
 * 初始化相关稿件
 */
const initRelatedContent = () => {
  if (!version.myApp) {
    const newsId = getSingleValueFromInput('newsId');
    fetchRelatedContent(newsId).then((res: any) => {
      if (Number(res.status) === 200) {
        if (res.list.length) {
          $('#related-content').show();
        }
        res.list.forEach((item: any) => {
          $('#content-list').append(initNewsTemplate(item.data));
        });
        const images = $('.t-news-image');
        const newImages = images.filter(
          (index, el) => $(el).attr('src') !== $(el).attr('data-src'),
        );
        // eslint-disable-next-line no-new
        new Lazyload(newImages);
        const tVideos = $('.t-news-video');
        if (tVideos && tVideos.length) {
          tVideos.each((index, el) => {
            videojs(el, {
              aspectRatio: '16:9',
              controls: true,
              playbackRates: [0.75, 1, 1.25, 1.5, 2],
              poster:
                el.getAttribute('poster') || process.env.DEFAULT_IMAGE_16_9,
            });
          });
        }
      }
    });
  }
};

/**
 * 初始化浏览量
 */
const initReadCount = () => {
  const readLikeNumber = $('#read-like-number');
  const newsId = getSingleValueFromInput('newsId');
  const channelId = getSingleValueFromInput('channelId');
  if (newsId && channelId) {
    fetchContentPropertie(newsId, channelId).then((res) => {
      const { praiseCount, visitCount, isShield, status, isReading } = res;
      if (Number(status) !== 200) {
        return;
      }
      if (isShield === 1) {
        $('#article-comment').remove();
      }
      if (Number(isReading) === 1 && readLikeNumber?.length && version.myApp) {
        $('#read-like-number').removeClass('hidden');
        $('#read-number-text').text(visitCount);
        $('#like-number-text').text(praiseCount);
      }
    });
  }
};
/**
 * 初始化相关活动
 */
const initRelatedActivity = () => {
  if ($('#related-activity')) {
    $('#related-activity').show();
  }
};
const addReadCount = () => {
  const newsId = getSingleValueFromInput('newsId');
  const contentType = getSingleValueFromInput('contentType');
  const siteId = getSingleValueFromInput('siteId');
  if (newsId && contentType && siteId) {
    fetchAddReadCountByLog(newsId, Number(contentType), siteId);
  }
};
(() => {
  const articleId = getSingleValueFromInput('newsId');
  if (version.myApp && version.userId) {
    userId = version.userId;
  }
  initVideo();
  const staticType = getSingleValueFromInput('staticType');
  if (Number(staticType)) {
    initSiteJson();
    getBrowerAppId((browerId) => {
      appId = browerId;
      addReadCount();
      initMediaLeader();
    });
    // 中宣部 H5 埋点：非 App 内打开时，稿件详情页浏览自行上报
    // 中宣优先：先初始化并上报，成功后（或超时兜底）再启动友盟，避免污染中宣 qt_queue。
    ZhongXuan.init().then(() => {
      trackArticleDetailPageView();
      setTimeout(() => {
        window.$ = window.jQuery;
      }, 2500);
      setTimeout(() => {
        YouMeng.initYoumeng();
        YouMeng.initYoumengLog(() => {
          YouMeng.pushRecord(
            { article_id: articleId },
            'gzcmc.xhc.h5.manuscript.view.click',
            'onload',
          );
        });
      }, 1000);
    });
    NanFang.init().then(() => {
      NanFang.openArticle(articleId);
    });
  }
  if (!Number(staticType)) {
    const query = getUrlQuery();
    if (!Number(query.isMobile)) {
      const previewSubtitle = $('.preview-subtitle');
      if (previewSubtitle) {
        previewSubtitle.show();
      }
      const previewKeyword = $('.preview-keyword');
      if (previewKeyword) {
        previewKeyword.show();
      }
      const previewDescription = $('.preview-description');
      if (previewDescription) {
        previewDescription.show();
      }
    }
  }
  // eslint-disable-next-line no-new
  new Lazyload();
  initReadCount();
  initAllMedia();
  initRelatedContent();
  initRelatedActivity();
  initWxSdk({
    wxShare: {
      title: getSingleValueFromInput('shareTitle') || document.title,
      desc: getSingleValueFromInput('shareDesc') || '',
      imgUrl: (getSingleValueFromInput('shareImgUrl') ||
        process.env.DEFAULT_SHARE_IMAGE) as string,
    },
  });
})();
